import { ApolloClient } from 'apollo-client';
import { HttpLink } from 'apollo-link-http';
import { InMemoryCache } from 'apollo-cache-inmemory';
import { ApolloLink } from 'apollo-link';
import { setContext } from 'apollo-link-context';
import Vue from 'vue';
import store from '../../store';

const setAuthorizationHeaderLink = setContext(request => new Promise((resolve, reject) => {
  Vue.$log.debug(request);
  store.dispatch('auth/getOrRefreshToken')
    .then((token) => {
      resolve({
        headers: { Authorization: token },
      });
    })
    .catch((err) => {
      Vue.$log.error(err);
      reject(err);
    });
}));

const link = ApolloLink.from([
  setAuthorizationHeaderLink,
  new HttpLink({
    uri: process.env.VUE_APP_API_URL,
  }),
]);

// Create the apollo client
const apolloClient = new ApolloClient({
  link,
  cache: new InMemoryCache(),
  connectToDevTools: true,
  defaultOptions: {
    watchQuery: {
      fetchPolicy: 'network-only',
      // errorPolicy: 'all',
    },
    query: {
      fetchPolicy: 'network-only',
      // errorPolicy: 'all',
    },
    mutate: {
      fetchPolicy: 'no-cache',
      // errorPolicy: 'all',
    },
  },
});

export default apolloClient;
